import React from 'react';

export const senders= [];

export const SendersContext = React.createContext({
  senders: senders
});